import { Component, Input } from '@angular/core';

@Component({
    selector: 'is-what-you-can-expect',
    templateUrl: './what-you-can-expect.component.html',
    styleUrls: ['./what-you-can-expect.component.scss'],
    standalone: false
})
export class WhatYouCanExpectComponent {
    @Input() lineOfBusiness: string;

    constructor() { }
}
